<template>
  <div
    v-bind="$attrs"
    class="strapi-content-wrapper text-h"
    v-html="richText"
  ></div>
</template>
<script lang="ts" setup>
defineProps<{ richText: string }>()
</script>

<style lang="postcss" scoped>
.strapi-content-wrapper {
  :deep(h2) {
    font-size: var(--h6-font-size);
    font-weight: var(--h6-font-weight);
    line-height: var(--h6-line-height);
    @apply mb-2;
  }
  :deep(h4) {
    font-size: var(--h6-font-size);
    font-weight: var(--h6-font-weight);
    line-height: var(--h6-line-height);
    @apply mb-2;
  }
  :deep(p) {
    @apply mb-4;
    letter-spacing: 0.32px;
  }
  :deep(ul) {
    @apply list-disc list-inside;
  }
}
</style>
